export interface AboutDto
{
    getAboutHeader(): string;
    getAboutContent():string;
    getContentHeader():string;
    getAboutDataList():AboutDataListDto[];
}

export class AboutDataListDto
{
    private data: AboutDataDto[];


    setData(data: AboutDataDto[])
    {
        this.data = data;
    }

    getData(): AboutDataDto[]
    {
        return this.data;
    }
}

export class AboutDataDto 
{
    private text: string;
    private iconName:string;
    private iconPath:string;
    private title:string;
    private style: object;

    setText(text: string)
    {
        this.text = text;
    }

    setStyle(style: object)
    {
        this.style = style;
    }

    getText(): string
    {
        return this.text;
    }

    getStyle(): object
    {
        return this.style;
    }

    setIconName(iconName:string):void
    {
        this.iconName = iconName;
    }

    getIconName():string{
        return this.iconName;
    }

    setTitle(title:string):void{
        this.title = title;
    }

    getTitle():string
    {
        return this.title;
    }
    
    setIconPath(iconPath:string):void
    {
        this.iconPath = iconPath;
    }

    getIconPath():string
    {
        return this.iconPath;
    }
    
}
export class AboutDtoImpl implements AboutDto
{
    private aboutHeader: string;
    private aboutContent: string;
    private aboutContentHeader:string;
    private dataList: AboutDataListDto[];

    getAboutHeader(): string 
    {
        return this.aboutHeader;
    }
    setAboutHeader(aboutHeader: string)
    {
        this.aboutHeader = aboutHeader;
    }

    setAboutContent(aboutContent:string):void{
        this.aboutContent = aboutContent;
    }
    getAboutContent():string{
        return this.aboutContent;
    }
    getContentHeader(): string
    {
        return this.aboutContentHeader;
    }
    setContentHeader(aboutContentHeader: string)
    {
        this.aboutContentHeader = aboutContentHeader;
    }

    setAboutDataList(datalist: AboutDataListDto[])
    {
        this.dataList = datalist;
    }

    getAboutDataList(): AboutDataListDto[]
    {
        return this.dataList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/about/aboutdto.ts